import { SignInPage as CoreSignInPage } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// Overrides plugin-app's DefaultSignInPage, which is hardcoded to
// `providers: ['guest']` and would otherwise render a Guest button no matter what
// the auth backend is configured with.
//
// The override works by extension id, not by import order: a no-name make() inside
// a module whose pluginId is 'app' produces `sign-in-page:app`, the same id the
// default registers under, so this replaces it. Adding a `name` here would create a
// second, differently-named extension and leave the Guest page in place - which is
// exactly the failure this file exists to fix.
export const SignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      // Mirrors auth.environment in app-config.yaml/app-config.production.yaml,
      // which is what actually selects the microsoft provider block on the
      // backend. Locally that key is unset (defaults to 'development') and only
      // the guest provider is registered, so offering the Microsoft button there
      // would 404 against /api/auth/microsoft/start.
      const authEnvironment = configApi.getOptionalString('auth.environment');

      if (authEnvironment !== 'production') {
        return <CoreSignInPage {...props} providers={['guest']} />;
      }

      return (
        <CoreSignInPage
          {...props}
          // ONE provider, not a list. Offering GitHub here as well would let the
          // same person arrive as user:default/bkoth or user:default/ben.koth
          // depending which button they pressed - two identities, two ownership
          // sets, two answers from the permission policy.
          //
          // GitHub is still configured in the auth backend, but as an
          // authorization provider: scmAuth obtains a token on demand for the
          // Actions and Insights tabs.
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Microsoft',
            message: 'Sign in with your Paradigm account',
            apiRef: microsoftAuthApiRef,
          }}
        />
      );
    },
  },
});
